function interpolate(messageId, params, named) {
    return messageId.replace(/{(\w+)}/g, (match, key) => {
        return params[key] ? `${params[key]}` : '';
    });
}
function createModulePolyfill() {
    return {
        gettext(messageId) {
            return `_${messageId}`;
        },
        ngettext(singular, plural, count) {
            return `_${singular || plural}`;
        },
        interpolate,
    };
}
function getModule() {
    const module = window.i18n;
    if (!(module === null || module === void 0 ? void 0 : module.jsi18n_initialized)) {
        return null;
    }
    return module;
}
function t(messageId, params) {
    const module = getModule() || createModulePolyfill();
    if (params) {
        if (params.count !== undefined) {
            return interpolate(module.ngettext(messageId, messageId, params.count), params);
        }
        return interpolate(module.gettext(messageId), params);
    }
    return module.gettext(messageId);
}

export { t };
//# sourceMappingURL=i18n.js.map
